class BankDetailViewController extends BaseTableViewController
{    
    static newInstance() : BankDetailViewController {
        let vc = new BankDetailViewController("bank-detail-view");
        vc.initWithResource("layout/bankaccount/BankDetailView.html");
        return vc;
    }

    private titleLabel:MUILabel = null;
    private optionsButton:MUIButton = null;
    private addButton:MUIButton = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.titleLabel = MUIOutlet(this, "title-lbl", "MUILabel");

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        this.addButton.setAction(this, this.addAccountAction);

        this.optionsButton = MUIOutlet(this, "action-btn", "MUIButton");
        this.optionsButton.setAction(this, this.showActions);

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;          
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);
        this.updateUI();
    }

    private _bank:Bank = null;
    set item(item:Bank) {
        this._bank = item;        
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false || this._bank == null) return;

        this.titleLabel.text = this._bank.name;

        this.fetchedResultsController = null;
        this.tableView.reloadData();
    }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.dequeueReusableCellWithIdentifier('BankAccountCell') as BankAccountCell;
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as BankAccount;
        
        cell.item = item;

        return cell;            
    }
    
    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){        
        this.selectedItem = this.fetchedResultsController.objectAtIndexPath(indexPath);
        this.showSelectedItemViewController();
    }

    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;
    
        let ad = MUIWebApplication.sharedInstance().delegate;

        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey('name', true)];
        let predicateFormat = 'bank.identifier == ' + this._bank.identifier;
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("BankAccount", sortDescriptors, predicateFormat);
        fetchRequest.relationshipKeyPathsForPrefetching = ["info"];
        
        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;    
        return this._fetchedResultsController;
    }
    
    private addAccountAction() {
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("ADD_BANK_ACCOUNT", "ADD BANK ACCOUNT"), MIOLocalizeString("ADD_BANK_ACCOUNT", "ADD BANK ACCOUNT"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField) {
            textField.placeholderText = MIOLocalizeString("ACCOUNT_NUMBER", "ACCOUNT NUMBER");
        });

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField) {
            textField.placeholderText = MIOLocalizeString("NAME", "NAME");
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("OK", "OK"), MUIAlertActionStyle.Default, this, function(this:BankDetailViewController) {
            let number = avc.textFields[0].text;
            let name = avc.textFields[1].text;
            this.addAccount(number, name);
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);
    }

    private addAccount(number:string, name:string){
        if (number == null) { AppHelper.showErrorMessage(this, MIOLocalizeString("BANK_ERROR_CREATION", "BANK ERROR CREATION"), MIOLocalizeString("THE_NUMBER_IS_NOT_OPTIONAL", "THE NUMBER IS NOT OPTIONAL")); return;}

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        let acc = MIOEntityDescription.insertNewObjectForEntityForName("BankAccount", ad.managedObjectContext) as BankAccount;
        acc.identifier = MIOUUID.UUID().UUIDString;
        acc.bank = this._bank;

        let info = MIOEntityDescription.insertNewObjectForEntityForName("BankAccountInfo", ad.managedObjectContext) as BankAccountInfo;
        info.title = name;
        info.number = number;
        acc.info = info;

        ad.managedObjectContext.save();
    }

    private showSelectedItemViewController(){
        let vc = BankAccountDetailViewController.newInstance();

        vc.item = this.selectedItem;
        this.navigationController.pushViewController(vc, true);
    }

    private showActions(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("BANK_OPTIONS", "BANK OPTIONS"), MIOLocalizeString("BANK_OPTIONS", "BANK OPTIONS"), MUIAlertViewStyle.Default);

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("ADD_WITH_OPEN_BANKING", "ADD WITH OPEN BANKING"), MUIAlertActionStyle.Default, this, function(this:BankDetailViewController) {
            this.bankLogin();
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("DELETE_BANK", "DELETE BANK"), MUIAlertActionStyle.Destructive, this, function(this:BankDetailViewController) {
            this.removeBank();
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);    
    }
    
    private bankLogin(){

    }

    private removeBank(){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.removeBank( this._bank, (error:string) => {
            if (error == null){
                ad.managedObjectContext.deleteObject(this._bank);
                ad.managedObjectContext.save();
                this.navigationController.popViewController(true);
            }
        });
    }   
}